import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { hasPermission } from '../../utils/permissions';
import DicomErrorsTable from '../../components/DicomErrorsTable';
import styles from '../assets/css/DetailDashboard.module.css';

const SettingsDicomErrorsPage = () => {
  const { user } = useAuth();

  return (
    <div className={styles.page}>
      <Link className={styles.backLink} to="/settings">← Back to Settings</Link>
      <div>
        <h1>DICOM Errors</h1>
        <p className={styles.muted}>
          Refused machines, failed pings, worklists filtered out by a machine&apos;s query, and MPPS problems,
          reported by Orthanc, the DICOM router, the MPPS service and the middleware. Repeats of the same error
          are grouped into one row.
        </p>
      </div>
      <DicomErrorsTable
        title="All errors"
        pageSize={20}
        canAcknowledge={hasPermission(user, 'equipment', 'write')}
      />
    </div>
  );
};

export default SettingsDicomErrorsPage;
